import React from "react";
import {FormattedMessage} from "react-intl";
import {connect} from "react-redux";
import PropTypes from "prop-types";
import {useLocation} from "react-router-dom";

import {IS_PRODUCT_JOURNEY} from "../../config";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../analytics";
import {ROUTES} from "../../routes";
import {isIframe} from "../../misc/helpers";
import {UserPopupContent} from "../visComponents/constants";
import {setUserPopupContent} from "../../actions/userFunctions";
import {setLookOverlayOpened} from "../../actions/lookFunctions";
import {LOOK_OVERLAYS} from "./core/constants";


const LookPolicyLinks = (props) => {

  const {position, isSimple, lookPageOpened, isMobile, fabricatorData, setUserPopupContent, setLookOverlayOpened} = props;
  const location = useLocation();

  const openLink = (linkKey) => {
    const baseUrl = fabricatorData.isAmericanStandard
      ? "https://www.americanstandard-us.com"
      : window.location && window.location.ancestorOrigins && window.location.ancestorOrigins["0"]
        ? window.location.ancestorOrigins["0"]
        : "https://grohe.us";

    Analytics.sendClickEvent(lookPageOpened === ROUTES.list
      ? LOOK_JOURNEY_ANALYTIC_EVENTS.lookListPolicyLinks + linkKey
      : LOOK_JOURNEY_ANALYTIC_EVENTS.lookCanvasPolicyLinks + linkKey
    );

    switch (linkKey) {
      case "terms": {
        const openUrl = fabricatorData.isAmericanStandard
          ? baseUrl + "/terms-of-use#Terms%20of%20Use"
          : baseUrl + "/legal-info";
        return window.open(openUrl, "_blank");
      }
      case "privacy": {
        const openUrl = fabricatorData.isAmericanStandard
          ? baseUrl + "/privacy-policy#Privacy"
          : baseUrl + "/privacy-policy";
        return window.open(openUrl, "_blank");
      }
      // case "socialPolicy":
      //   return window.open(baseUrl + "/social-policy", "_blank");
      // case "legalInfo":
      //   return window.open(baseUrl + (fabricatorData.isAmericanStandard ? "/lead-generation-policy" : "/legal-info"), "_blank");
      case "privacyQC": {
        setUserPopupContent(UserPopupContent.terms);
        setLookOverlayOpened(LOOK_OVERLAYS.leadCapture, "termsOnly");
        break;
      }
      default:
        return
    }
  }

  const isLixil = isIframe() && fabricatorData.isLixil;

  return (
    <div className={"look-policy" + (IS_PRODUCT_JOURNEY || position === "left" ? " look-policy--left" : " look-policy--center")
      + ((position === "left" && !IS_PRODUCT_JOURNEY) || isSimple ? " look-policy--simple" : "")
      + (location && location.pathname.includes(ROUTES.wizard) && isMobile ? " look-policy--hidden" : "")}>
      <ul className="look-policy__links">
        {isLixil ? ["terms", "privacy"].map(linkKey => {
          return (
            <li className="look-policy__links-item" key={linkKey}>
              <span className="look-link" onClick={() => openLink(linkKey)}>
                <FormattedMessage id={"footer.links." + linkKey}/>
              </span>
            </li>
          )
        }) : (
          <li className="look-policy__links-item">
            <span className="look-link" onClick={() => openLink("privacyQC")}>
              <FormattedMessage id="footer.links.privacyFull"/>
            </span>
          </li>
        )}
      </ul>
    </div>
  )
};

LookPolicyLinks.propTypes = {
  position: PropTypes.string,
  isSimple: PropTypes.bool
}

const mapStateToProps = (store) => {
  const {lookPageOpened} = store.lookState;
  const {isMobile} = store.serverState;
  const fabricatorData = store.fabricatorState;
  return {
    lookPageOpened,
    isMobile,
    fabricatorData
  };
};

const mapDispatchToProps = {
  setUserPopupContent,
  setLookOverlayOpened
}

export default connect(mapStateToProps, mapDispatchToProps)(LookPolicyLinks)
